export default __webpack_public_path__ + "static/media/eIcon5.de833f2a.svg";